import React from 'react'
import PropTypes from 'prop-types'

import { useTheme } from 'styled-components'
import themeGet from '@styled-system/theme-get'

import { Dots, Heading } from 'Components/Blocks/_Legacy'
import { Border, Column, Motion, Text, Wrapper } from 'Components/UI'

import { iconCpuGlyph } from 'Assets/_Legacy/CtoPage'

import { STACK_CARDS } from './data'
import {
  Card,
  CardContainer,
  Container,
  Content,
  DotsContainer,
  StyledImage,
} from './styles'

function TechnologyStack({ data }) {
  const theme = useTheme()

  return (
    <>
      <Border almond topRight />

      <Container>
        <Content>
          <Wrapper wayPointTop>
            <Motion>
              {/* `as` was a dead prop on Heading (dropped by pick()) — the
                  title renders as the default h2; the page h1 is the Hero. */}
              <Heading
                fontSizes={{ title: [24, 24, 45], sub: [14, 14, 16] }}
                tagGlyph={iconCpuGlyph}
                tagText={data?.stackTagText}
                tagTextAs="h4"
                titleText={{
                  first: { text: data?.stackTitleRegular, bold: false },
                  second: { text: data?.stackTitleBold, bold: true },
                }}
              />
            </Motion>

            <Motion>
              <CardContainer mt={[52, 52, 64, 64, 80]}>
                <DotsContainer>
                  <Dots
                    columns={18}
                    corners={[true, true, true, true]}
                    margin={5}
                    primary
                    rows={8}
                  />
                </DotsContainer>

                {STACK_CARDS.map(card => (
                  <Card key={card.header}>
                    {/* The technology name sits immediately beside the
                        logo, so per the Phase-3 convention the image is
                        decorative rather than a second announcement. */}
                    <StyledImage alt="" src={card.image.src} />
                    <Column justifyCenter ml={[4, 4, 4, 5]}>
                      <Text bold fontSize={20} mb={[0, 0, 0, 3]}>
                        {card.header}
                      </Text>
                      <Text fontSize={16} light>
                        {card.caption}
                      </Text>
                    </Column>
                  </Card>
                ))}
              </CardContainer>
            </Motion>
          </Wrapper>
        </Content>
      </Container>

      <Border almond bottomLeft />

      <Border bg={themeGet('colors.bg.almond')({ theme })} topRight />
    </>
  )
}

TechnologyStack.defaultProps = {
  data: {},
}

TechnologyStack.propTypes = {
  data: PropTypes.object,
}

export default TechnologyStack
